var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn btn-primary rounded', _vm.elementClass],attrs:{"type":"button"}},[_vm._t("default",function(){return [_c('i',{class:['pr-0 pb-1', _vm.iconClass]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }